import {
  Connection,
  PublicKey,
  Transaction,
  TransactionInstruction,
} from "@solana/web3.js";
import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  Token,
  TOKEN_PROGRAM_ID,
} from "@solana/spl-token";

export const raffleDefaults = [
  {
    raffleObjectId: "627edaba922bdd389c51d4ca",
    raffleId: "1",
    pricePerTicket: 20,
    receiverWallet: "CS15KgeHBTdwEiZ5kqXSY7Y9qqhqKfA5DVJzped5xrB7",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-13T12:00:00+00:00",
    endDate: "2022-05-15T18:00:00+00:00",
    raffleName: "1x Zenjin WL",
    raffleImage:
      "https://cdn.discordapp.com/attachments/955874878253305926/961731725468242010/Dragon_1_6.gif",
    raffleDesc:
      "Zenjin Viperz are a collection of 2,000 NFTs on the #Solana Blockchain.",
    tokenLink: null,
    winner: [
      "CQ8S5u5cTF8Mvz4Jn6RW2dMZMNYustB54cXKEcc8GPw7 - Fasholo | 49TH#0961",
    ],
    type: "whitelist",
    ticketsSold: 424,
  },
  {
    raffleObjectId: "62841ef7a92e0e58f800751c",
    raffleId: "2",
    pricePerTicket: 20,
    receiverWallet: "CS2yCTrxyJ31CsfUvKLn7bFT3cnGUSvuqZXrreYS9r4k",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-17T12:00:00+00:00",
    endDate: "2022-05-19T06:00:00+00:00",
    raffleName: "Tombstoned High Society",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/976244818965573632/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: ["2sjpRFANuvTKJpNdjjDbae9mumNwxTgaxJqbb2YEox7Q"],
    type: null,
    ticketsSold: 499,
  },
  {
    raffleObjectId: "6288b875a696a588354be9d9",
    raffleId: "3",
    pricePerTicket: 20,
    receiverWallet: "CS38TgUFFghQnZoLjuPp1nno2jBHyD8xsB3YEPx96Zfe",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-21T12:00:00+00:00",
    endDate: "2022-05-23T06:00:00+00:00",
    raffleName: "Zenjin Viperz #133",
    raffleImage:
      "https://mqn2g3tt44vzuuhws3p366tl2h3k6cvmy7ovdrtovubgwmmr4i.arweave.net/ZBujbnPnK5pQ9pbfv3pr0favCqzH3VHGbq0C_azGR4s",
    raffleDesc: "",
    tokenLink: null,
    winner: ["CQ8S5u5cTF8Mvz4Jn6RW2dMZMNYustB54cXKEcc8GPw7"],
    type: null,
    ticketsSold: null,
  },
  {
    raffleObjectId: "6288b875a696a588354be9d9",
    raffleId: "4",
    pricePerTicket: 20,
    receiverWallet: "CS38TgUFFghQnZoLjuPp1nno2jBHyD8xsB3YEPx96Zfe",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-21T12:00:00+00:00",
    endDate: "2022-05-23T06:00:00+00:00",
    raffleName: "Zenjin Viperz #133",
    raffleImage:
      "https://mqn2g3tt44vzuuhws3p366tl2h3k6cvmy7ovdrtovubgwmmr4i.arweave.net/ZBujbnPnK5pQ9pbfv3pr0favCqzH3VHGbq0C_azGR4s",
    raffleDesc: "",
    tokenLink: null,
    winner: ["CQ8S5u5cTF8Mvz4Jn6RW2dMZMNYustB54cXKEcc8GPw7"],
    type: null,
    ticketsSold: null,
  },
  {
    raffleObjectId: "628fa6916520ee78b5c84732",
    raffleId: "5",
    pricePerTicket: 20,
    receiverWallet: "CS38TgUFFghQnZoLjuPp1nno2jBHyD8xsB3YEPx96Zfe",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-26T17:00:00+00:00",
    endDate: "2022-05-28T17:00:00+00:00",
    raffleName: "1x Honey Genesis Bee",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/979144707345096714/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: ["HrmpSKbo9jo73dw2J3DZGzpPdd6JXiui5LeCPRptBXBr"],
    type: null,
    ticketsSold: null,
  },
  {
    raffleObjectId: "628fa696108d01d0da223b45",
    raffleId: "6",
    pricePerTicket: 10,
    receiverWallet: "CS38TgUFFghQnZoLjuPp1nno2jBHyD8xsB3YEPx96Zfe",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 3,
    startDate: "2022-05-26T17:00:00+00:00",
    endDate: "2022-05-28T17:00:00+00:00",
    raffleName: "3x Cosmic Sentinels",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/979144707609350214/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: ["AA3JouC75pkwbQM2srWGrwHjvgopjPARfhUzcjbo82am"],
    type: null,
    ticketsSold: null,
  },
  {
    raffleObjectId: "628ffe4fa32a87c41ac6da25",
    raffleId: "7",
    pricePerTicket: 20,
    receiverWallet: "CS15KgeHBTdwEiZ5kqXSY7Y9qqhqKfA5DVJzped5xrB7",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 5,
    startDate: "2022-05-26T22:00:00+00:00",
    endDate: "2022-05-28T06:00:00+00:00",
    raffleName: "5x Susanoo WL",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/979493837108043836/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: [
      "GYuhH9MZ5Sp9jDMnrL8XuVAjQrDyCkcDUoBk5ngCvXSc  - kilo#8408",
      "G1Q5nXCotzurj2ygbzh17vA8Dc7uKRxF47px6x5GiyTf - JCFP#8961",
      "2sjpRFANuvTKJpNdjjDbae9mumNwxTgaxJqbb2YEox7Q - bownnerz | god like sentinel #9488",
      "6buJBg6FKLckpPT8ssmhtGUUY2iR1WxR6BawB3gWvqCu - trvl.#0420",
      "2sjpRFANuvTKJpNdjjDbae9mumNwxTgaxJqbb2YEox7Q - bownnerz | god like sentinel #9488",
    ],
    type: "whitelist",
    ticketsSold: null,
  },
  {
    raffleObjectId: "6294096ba15c88bc3055945d",
    raffleId: "8",
    pricePerTicket: 50,
    receiverWallet: "CS15KgeHBTdwEiZ5kqXSY7Y9qqhqKfA5DVJzped5xrB7",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-05-30T12:00:00+00:00",
    endDate: "2022-05-30T16:00:00+00:00",
    raffleName: "1x Susanoo WL",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/979493837108043836/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: [
      "HN7zQ5UyebfuRoUnULsUHNjSCq1vSpicAyhZUiCvS17m - Paulysolpumper#5157",
    ],
    type: "whitelist",
    ticketsSold: null,
    limit: true,
  },
  {
    raffleObjectId: "62940977d7c038ab8e24fb2e",
    raffleId: "9",
    pricePerTicket: 20,
    receiverWallet: "CS15KgeHBTdwEiZ5kqXSY7Y9qqhqKfA5DVJzped5xrB7",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 8,
    startDate: "2022-05-30T00:00:00+00:00",
    endDate: "2022-05-31T12:00:00+00:00",
    raffleName: "8x Chilli Dogs WL",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/980582044298014791/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: [
      "2sjpRFANuvTKJpNdjjDbae9mumNwxTgaxJqbb2YEox7Q - bownnerz | god like sentinel #9488",
      "ATV6vXRxocF4peVYvXpCA6rwHJfnfjWZzoBNeXVRhJPE - Gate11#2194",
      "F5RFpxkuTL1zwr87bvzgWAaK54MsgMJ5JqnCz5ddo2RT - RuskyMalone#5936",
      "EyvJNBEdakAEFnCEs7qfV5nvtx9aLLF1HuhZ2Zo83Ujr - YuraaN#0623",
      "35HJ6CFFQN2n3BhDGag67b4jkcpHWnts2Njpo5Lf3ZGS - Orni#0001",
      "6jLcMGZjtx6MD2RrEAKETjSJUkhqUMbyuNgwHLaneSD2 - chang#9812",
      "HMrf48PpGt6L4zWEcSN4HB6Fwfrz3KrCsJZmHjmiNpEt - Shiv.sol#2881",
      "9zRGPTm6ti6Eto3WW6jHGqGXUFBmJNh8ogp2FYmPdEoS - metaboy#0479",
    ],
    type: "whitelist",
    ticketsSold: null,
  },
  {
    raffleObjectId: "62b0339aedfca816a0543277",
    raffleId: "10",
    pricePerTicket: 20,
    receiverWallet: "CS15KgeHBTdwEiZ5kqXSY7Y9qqhqKfA5DVJzped5xrB7",
    tokenDecimal: 9,
    tokenMint: "MRLY2ScVMxXJTieiDi2Ywdm8VjEKeLcY4THL2UyhHRA",
    winners: 1,
    startDate: "2022-06-20T00:00:00+00:00",
    endDate: "2022-06-23T12:00:00+00:00",
    raffleName: "Baked Beaver",
    raffleImage:
      "https://cdn.discordapp.com/attachments/960987954577305622/988232621957984406/unknown.png",
    raffleDesc: "",
    tokenLink: null,
    winner: ["CQ8S5u5cTF8Mvz4Jn6RW2dMZMNYustB54cXKEcc8GPw7"],
    type: null,
    ticketsSold: null,
  },
];

export const tx_transfer_spl = async (
  conn: Connection,
  from: PublicKey,
  to: PublicKey,
  token: PublicKey,
  amount: number,
  decimals: number,
  sendTransaction: Function
) => {
  const source = await Token.getAssociatedTokenAddress(
    ASSOCIATED_TOKEN_PROGRAM_ID,
    TOKEN_PROGRAM_ID,
    token,
    from
  );

  if ((await conn.getParsedAccountInfo(from)).value == null) {
    console.error("can't debit from an account that doesn't exist");
    return;
  }

  const dest = await Token.getAssociatedTokenAddress(
    ASSOCIATED_TOKEN_PROGRAM_ID,
    TOKEN_PROGRAM_ID,
    token,
    to
  );

  const txs = new Transaction();

  if ((await conn.getParsedAccountInfo(dest)).value == null) {
    txs.add(
      Token.createAssociatedTokenAccountInstruction(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        token,
        dest,
        to,
        from
      )
    );
  }

  txs.add(
    Token.createTransferCheckedInstruction(
      TOKEN_PROGRAM_ID,
      source,
      token,
      dest,
      from,
      [],
      amount * Math.pow(10, decimals),
      decimals
    )
  );

  return txs;
};

export const buyTickets = async (
  raffle: any,
  n_tickets: number,
  connection: any,
  publicKey: PublicKey,
  sendTransaction: Function,
  discordId?: string
) => {
  const txs = new Transaction();

  const amount = n_tickets * raffle.pricePerTicket;

  const transferIx = await tx_transfer_spl(
    connection,
    publicKey!,
    new PublicKey(raffle.receiverWallet),
    new PublicKey(raffle.tokenMint),
    amount,
    raffle.tokenDecimal,
    sendTransaction
  );

  txs.add(
    new TransactionInstruction({
      keys: [{ pubkey: publicKey!, isSigner: true, isWritable: true }],
      data: Buffer.from(
        `Raffle #${raffle.raffleId} - ${amount / raffle.pricePerTicket}`,
        "utf-8"
      ),
      programId: new PublicKey("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr"),
    })
  );

  discordId &&
    txs.add(
      new TransactionInstruction({
        keys: [{ pubkey: publicKey!, isSigner: true, isWritable: true }],
        data: Buffer.from(
          `${discordId ? `Discord ID - ${discordId}` : ""}`,
          "utf-8"
        ),
        programId: new PublicKey("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr"),
      })
    );

  if (transferIx === null || transferIx === undefined) {
    return;
  }

  txs.add(transferIx);

  try {
    let blockhashObj = await connection.getRecentBlockhash();
    txs.recentBlockhash = blockhashObj.blockhash;
    txs.feePayer = publicKey!;

    const txid = await sendTransaction(txs, connection);

    let done = false;
    let status = {
      slot: 0,
      confirmations: 0,
      err: null,
    };
    // let subId = 0;

    status = await new Promise(async (resolve, reject) => {
      setTimeout(() => {
        if (done) {
          return;
        }
        done = true;
        console.log("Rejecting for timeout...");
        reject({ timeout: true });
      }, 120000);

      while (!done) {
        // eslint-disable-next-line no-loop-func
        (async () => {
          try {
            const signatureStatuses = await connection.getSignatureStatuses([
              txid,
            ]);
            status = signatureStatuses && signatureStatuses.value[0];
            if (!done) {
              if (!status) {
                console.log("REST null result for", txid, status);
              } else if (status.err) {
                console.log("REST error for", txid, status);
                done = true;
                reject(status.err);
              } else if (!status.confirmations) {
                console.log("REST no confirmations for", txid, status);
              } else {
                console.log("REST confirmation for", txid, status);
                done = true;
                resolve(status);
              }
            }
          } catch (e) {
            if (!done) {
              console.log("REST connection error: txid", txid, e);
            }
          }
        })();
        await sleep(2000);
      }
    });

    done = true;
    console.log("Returning status", status);
    return status;
  } catch (e) {
    console.error(e);
  }
};

const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
